"use client"

import { useState } from "react"
import { Button } from "@/components/ui/button"
import { CookieConsent } from "@/components/cookie-consent"
import { useI18n } from "@/contexts/lang-context"

export function CookiePreferencesButton() {
  const { t } = useI18n()
  const [showPreferences, setShowPreferences] = useState(false)

  return (
    <>
      <Button variant="outline" size="sm" onClick={() => setShowPreferences(true)}>
        {t("cookies.manage")}
      </Button>
      {showPreferences && <CookieConsent forceOpen={true} onClose={() => setShowPreferences(false)} />}
    </>
  )
}
